module.exports = __webpack_public_path__ + "img/IMG-20190915-WA0027.3c97ae71.jpg";